/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thiswillmarktheeventascanceledandnotifyattendees9Inputs */

const en_thiswillmarktheeventascanceledandnotifyattendees9 = /** @type {(inputs: Thiswillmarktheeventascanceledandnotifyattendees9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will mark the event as canceled and notify attendees.`)
};

const de_thiswillmarktheeventascanceledandnotifyattendees9 = /** @type {(inputs: Thiswillmarktheeventascanceledandnotifyattendees9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Event wird als abgesagt markiert und alle Teilnehmer bekommen Bescheid.`)
};

/**
* | output |
* | --- |
* | "This will mark the event as canceled and notify attendees." |
*
* @param {Thiswillmarktheeventascanceledandnotifyattendees9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const thiswillmarktheeventascanceledandnotifyattendees9 = /** @type {((inputs?: Thiswillmarktheeventascanceledandnotifyattendees9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thiswillmarktheeventascanceledandnotifyattendees9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thiswillmarktheeventascanceledandnotifyattendees9(inputs)
	return de_thiswillmarktheeventascanceledandnotifyattendees9(inputs)
});
export { thiswillmarktheeventascanceledandnotifyattendees9 as "thisWillMarkTheEventAsCanceledAndNotifyAttendees" }